'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ROUTES, _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxSimple = require('redux-simple');

var _reactAddonsTransitionGroup = require('react-addons-transition-group');

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _CSSCore = require('fbjs/lib/CSSCore');

var _CSSCore2 = _interopRequireDefault(_CSSCore);

var _App = require('../../components/App');

var _routing = require('../../actions/routing');

var _routing2 = require('../../constants/routing');

var _actionTypes = require('../../constants/actionTypes');

var _UserPage = require('../User/UserPage');

var _UserPage2 = _interopRequireDefault(_UserPage);

var _ProjectPage = require('../Projects/ProjectPage');

var _ProjectPage2 = _interopRequireDefault(_ProjectPage);

var _NodePage = require('../Nodes/NodePage');

var _NodePage2 = _interopRequireDefault(_NodePage);

var _TestPage = require('../Test/TestPage');

var _TestPage2 = _interopRequireDefault(_TestPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* injects from baggage-loader */
var styles = require('./AnimatedRoutes.pcss');

var animation = {
  time: 300,
  rightOut: styles.rightOut,
  rightIn: styles.rightIn,
  leftOut: styles.leftOut,
  pause: styles.pause
};

var ROUTES = (_ROUTES = {}, _defineProperty(_ROUTES, _routing2.JALAN_USER_LIST, [_UserPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_INDEX, [_UserPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_INDEX_PROJECT, [_UserPage2.default, _ProjectPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_PROJECT, [_ProjectPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_PROJECT_NODE, [_ProjectPage2.default, _NodePage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_NODE, [_NodePage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_TEST, [_TestPage2.default]), _ROUTES);

var COMPONENT_ORDER = [_UserPage2.default, _ProjectPage2.default, _NodePage2.default];

var getState = function getState(state) {
  return {
    routeType: state.routing.type
  };
};

var AnimatedRoutes = (_dec = (0, _reduxSimple.connect)(getState, {
  goLeft: _routing.goLeft,
  goRight: _routing.goRight,
  routeTransitionFinished: function routeTransitionFinished() {
    return {
      type: _actionTypes.ROUTE_TRANSITION_FINISHED
    };
  }
}), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(AnimatedRoutes, _Component);

  function AnimatedRoutes() {
    _classCallCheck(this, AnimatedRoutes);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(AnimatedRoutes).apply(this, arguments));
  }

  _createClass(AnimatedRoutes, [{
    key: 'elementHasParentLink',
    value: function elementHasParentLink(node) {
      var element = node;
      while (element) {
        if (element.nodeName === 'A') return true;
        element = element.parentNode;
      }
      return false;
    }
  }, {
    key: 'goLeft',
    value: function goLeft(e) {
      if (!this.elementHasParentLink(e.target)) {
        this.props.goLeft();
      }
    }
  }, {
    key: 'goRight',
    value: function goRight(e) {
      e.preventDefault();

      this.props.goRight();
    }
  }, {
    key: 'getLeftRoute',
    value: function getLeftRoute() {
      return (0, _reactDom.findDOMNode)(this).childNodes[0];
    }
  }, {
    key: 'transition',
    value: function transition(isEnter, isLeftRoute, callback) {
      var _this2 = this;

      if (isEnter) {
        callback();
      } else {
        setTimeout(callback, animation.time);
      }
      if (isLeftRoute) {
        _CSSCore2.default.addClass(this.getLeftRoute(), animation.leftOut);
        if (isEnter) {
          _CSSCore2.default.addClass(this.getLeftRoute(), animation.pause);
          setTimeout(function () {
            _CSSCore2.default.removeClass(_this2.getLeftRoute(), animation.leftOut);
            _CSSCore2.default.removeClass(_this2.getLeftRoute(), animation.pause);
          }, 0);
        }
      }
    }
  }, {
    key: 'prepareRoutes',
    value: function prepareRoutes() {
      var _this3 = this;

      var routeType = this.props.routeType;

      var routes = ROUTES[routeType];

      return routes.map(function (routeComponent, index) {
        var isLeftRoute = index === 0;
        var className = (0, _classnames2.default)(styles.route, isLeftRoute && styles.leftRoute || styles.rightRoute, isLeftRoute && routes.length === 1 && animation.rightOut, isLeftRoute && routes.length === 2 && animation.rightIn);
        var props = {
          key: COMPONENT_ORDER.indexOf(routeComponent),
          className: className,
          enter: _this3.transition.bind(_this3, true, isLeftRoute),
          leave: _this3.transition.bind(_this3, false, isLeftRoute),
          routeTransitionFinished: _this3.props.routeTransitionFinished
        };
        if (routes.length === 2) props.onClick = isLeftRoute ? _this3.goLeft.bind(_this3) : _this3.goRight.bind(_this3);

        return _react2.default.createElement(
          _App.AnimatedRoute,
          props,
          _react2.default.createElement(routeComponent)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactAddonsTransitionGroup2.default,
        {
          component: 'div',
          className: styles.routes
        },
        this.prepareRoutes()
      );
    }
  }]);

  return AnimatedRoutes;
}(_react.Component), _class2.propTypes = {
  routeType: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = AnimatedRoutes;


//////////////////
// WEBPACK FOOTER
// ./app/components/App/AnimatedRoutes.js
// module id = 208
// module chunks = 1